import React from "react";
import { useTranslation } from "react-i18next";

import {
  HvGlobalActions,
  HvTypography,
  HvGrid,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";
import MembersContent from "./MembersContent";

const Members: React.FC = () => {
  const { t } = useTranslation("incidentAddEdit");
  const classes = useStyles();

  return (
    <HvGrid container className={classes.root}>
      <HvGrid xs={12} sm={12} item>
        <HvGlobalActions title={t("members.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("members.description")}
        </HvTypography>
      </HvGrid>
      <MembersContent />
    </HvGrid>
  );
};

export default Members;
